<template>
  <vx-card no-shadow>
    <h2 class="mb-6">User - General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Deactivated:</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full" v-if="user">
        <p>{{ user.isDeactivated | yesno }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>IDP ID:</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full" v-if="user">
        <p>{{ user.idpId }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          v-if="user"
          class="w-full"
          v-model="user.firstName"
          placeholder="First Name"
          readonly
          disabled
        />
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          v-if="user"
          class="w-full"
          v-model="user.lastName"
          placeholder="Last Name"
          readonly
          disabled
        />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Contact</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>E-mail:</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          v-if="user"
          class="w-full"
          v-model="user.email"
          type="email"
          placeholder="Email"
          readonly
          disabled
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Phone</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full" style="display: flex; align-items: flex-end">
        <vs-select v-if="user" class="mt-2" v-model="user.phoneCountryCode" readonly disabled>
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in phoneCountryCodes"
          />
        </vs-select>

        <vs-input
          v-if="user"
          v-validate="'numeric'"
          name="phone"
          v-model="user.phone"
          placeholder="Phone..."
          class="w-full ml-2"
          readonly
          disabled
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full"></div>
      <div class="vx-col sm:w-2/5 w-full" style="display: flex; align-items: flex-end">
        <div class="text-danger text-sm" v-show="errors.has('phone')">
          {{ errors.first("phone") }}
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Job Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          v-if="user"
          class="w-full"
          v-model="user.jobTitle"
          placeholder="Job title..."
          readonly
          disabled
        />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Permissions</h5>
    </div>

    <div class="vx-row mb-6" v-if="false"> <!-- Deprecated in favor of IDAM but kept for legacy support -->
      <div class="vx-col sm:w-1/5 w-full">
        <span>Role</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <div v-if="user" class="horizontal-row">
          <vs-button
            :disabled="!isAdmin"
            v-for="role in roles"
            :key="role.id"
            @click="onChangeRole(role.id)"
            :color="user.role == role.id ? 'success' : 'rgb(80, 80, 80)'"
            :type="user.role == role.id ? 'filled' : 'border'"
            icon-pack="feather"
            :icon="user.role == role.id ? 'icon-check' : ''"
            class="mr-3 selection-button"
            >{{ role.label }}</vs-button
          >
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Tags</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips class="tags" color="rgb(145, 32, 159)" placeholder="New Tag" v-model="tags">
          <vs-chip :key="tag" @click="removeTag(tag)" v-for="tag in tags" closable>
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div>

    <vs-divider />
    <div v-if="b2cUser">
      <div class="vx-col lg:w-1/1 w-full">
        <h5 class="mb-2">Azure B2C</h5>
        <p class="mb-6">This information is for technical use only.</p>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>B2C profile ID:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>{{ b2cUser.idpId }}</p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>B2C E-mail:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>{{ b2cUser.idpEmail }}</p>
          <vs-chip color="red" v-if="b2cUser.idpEmail.toLowerCase() !== user.email.toLowerCase()">
            Warning: B2C and IDM E-mail not equal
          </vs-chip>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Account enabled:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>{{ b2cUser.accountEnabled | yesno }}</p>
          <vs-chip color="red" v-if="b2cUser.accountEnabled === user.isDeactivated">
            Warning: Activation status in B2C and IDM not equal
          </vs-chip>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Custom claims IDM role set to:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>{{ getClaim("UserRole") }}</p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Custom claims IDM ID set to:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>{{ getClaim("UserId") }}</p>
          <vs-chip color="red" v-if="getClaim('UserId') !== user.userId">
            Warning: Claimed IDM ID not equal to actual IDM ID
          </vs-chip>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="hasB2cError && hasPermission('life.admin.user.btoc.edit')">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Auto-fix</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-button @click="openConfirmFix" color="warning" id="toggle-autofix-user-button" class="mt-2"
            >Attempt auto-fix</vs-button
          >
        </div>
      </div>

      <vs-divider />
    </div>

    <div v-if="user" class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full"></div>
      <div class="vx-col sm:w-2/5 w-full" style="display: flex; align-items: flex-end">
        <vs-button
          v-if="!user.isDeactivated && false"
          @click="openConfirmDeactivateUser"
          color="warning"
          id="toggle-deactivate-user-button"
          class="mt-2"
          >Deactivate User</vs-button
        >
        <span v-if="user.isDeactivated"
          ><strong>User is deactivated.</strong> You can still update the user profile, but the user will not
          be able to login. If you wish to reactivate this user, it should be done through Planday.<br />User
          was deactivated on {{ moment(user.deactivatedOn).format("HH:mm:ss DD-MM-YYYY ") }}</span
        >
        <vs-button
          v-if="user.isDeactivated && false"
          @click="activateUser"
          color="primary"
          id="toggle-activate-user-button"
          class="mt-2"
          >Invite User</vs-button
        >
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        v-if="hasPermission('life.admin.user.general.edit')"
        @click="saveInfo"
        id="save-button"
        class="ml-auto mt-2"
        >Save Changes</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import moment from "moment";
export default {
  computed: {
    hasB2cError() {
      return (
        this.b2cUser.idpEmail.toLowerCase() !== this.user.email.toLowerCase() ||
        this.b2cUser.accountEnabled === this.user.isDeactivated ||
        this.getClaim("UserId") !== this.user.userId
      );
    },
    isAdmin() {
      const user = this.$AuthService.getUser();

      return user.role === "Admin";
    },
  },
  data() {
    return {
      moment,
      tags: [],

      user: null,
      b2cUser: null,

      roles: [
        {
          id: 0,
          label: "User",
        },
        {
          id: 1,
          label: "Admin",
        },
        {
          id: 2,
          label: "VenueAdmin",
        },
      ],

      phoneCountryCodes: [
        { text: "Denmark (+45)", value: "+45" },
        { text: "Sweden (+46)", value: "+46" },
        { text: "Norway (+47)", value: "+47" },
        { text: "UK (+44)", value: "+44" },
        { text: "Finland (+358)", value: "+358" },
      ],
    };
  },
  methods: {
    getClaim(claimType) {
      if (!this.b2cUser) return "";
      return this.b2cUser.claims
        .filter(e => e.split(claimType + ":").length > 1)[0]
        .split(claimType + ":")[1];
    },
    activateUser: function () {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#toggle-activate-user-button",
        scale: 0.45,
      });

      this.$http
        .post(process.env.VUE_APP_IDM_API + "/users/invites/" + this.user.userId)
        .then((/*resp*/) => {
          this.user.isDeactivated = false;

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "User activated",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not send activate User",
          });
        })
        .finally(() => {
          this.$vs.loading.close("#toggle-activate-user-button > .con-vs-loading");
        });
    },

    openConfirmFix() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to attempt an auto-fix? Only technical users should do this.",
        accept: this.autofix,
      });
    },

    openConfirmDeactivateUser() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure that you would like to deactivate the user?",
        accept: this.deactivateUser,
      });
    },

    deactivateUser: function () {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#toggle-deactivate-user-button",
        scale: 0.45,
      });
      this.$http
        .delete(process.env.VUE_APP_IDM_API + "/users/" + this.user.userId)
        .then((/*resp*/) => {
          this.user.isDeactivated = true;

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "User deactivated",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not send deactivate User",
          });
        })
        .finally(() => {
          this.$vs.loading.close("#toggle-deactivate-user-button > .con-vs-loading");
        });
    },
    autofix() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#toggle-autofix-user-button",
        scale: 0.45,
      });
      this.$http
        .post(process.env.VUE_APP_API + "/users/b2c/autofix/" + this.user.userId)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Success. Please reload page",
          });
          window.location.reload();
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not autofix User",
          });
        })
        .finally(() => {
          this.$vs.loading.close("#toggle-autofix-user-button > .con-vs-loading");
        });
    },
    removeTag(item) {
      this.tags.splice(this.tags.indexOf(item), 1);
    },

    onChangeRole: function (roleId) {
      if (!this.hasPermission("life.admin.user.general.edit")) return;
      this.user.role = roleId;

      this.updateUserRole(roleId);
    },

    updateUserRole: function (role) {
      this.$vs.loading();

      this.$http
        .put(process.env.VUE_APP_API + "/users/role/" + this.user.userId + "/" + role)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Role changed",
          });
        })
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could change role:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getUser: function (userId) {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/users/" + userId)
        .then(resp => {
          this.user = resp.data;
          this.getB2cUser(this.user.idpId);

          if (this.user.tags) {
            this.tags = this.user.tags;
          } else {
            this.tags = [];
          }
        })
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not fetch user:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getB2cUser: function (userId) {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/users/b2c/" + userId)
        .then(resp => {
          this.b2cUser = resp.data;
        })
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not fetch b2c user:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    saveInfo: function () {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45,
      });

      const payload = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        ssn: this.user.ssn,
        email: this.user.email,
        phone: this.user.phone,
        phoneCountryCode: this.user.phoneCountryCode,
        jobTitle: this.user.jobTitle,
        tags: this.tags,
      };

      this.$http
        .put(process.env.VUE_APP_API + "/user/" + this.user.userId + "/info/general", payload)
        .then(resp => {
          console.log(resp.data);

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Info updated",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not update info",
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    },
  },
  created() {
    this.getUser(this.$route.params.userId);
  },
};
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.con-chips--remove-all {
  display: none !important;
}
</style>